var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawStars5Pgw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.907,
    height: 588.82,
    viewBox: "0 0 799.907 588.82",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-580 -230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.935,453.864c-3.486,40.26-21.036,79.165-46.073,111.341q-1.57,2.019-3.177,4-3.617,4.458-7.42,8.747-4.654,5.285-9.579,10.327-4.009,4.149-8.205,8.121-3.238,3.1-6.551,6.075c-26.569,24.008-57.091,43.82-88.538,61.147-61.371,33.8-128.639,59.409-198.608,63.137s-142.994-16.317-194.3-64.034c-69.146-64.306-88.445-171.562-60.371-261.717,18.672-59.979,56.782-114.238,108.649-149.676,51.418-35.129,116.284-50.942,177.674-40.606,49.007-29.784,113.163-30.354,166.441-8.308,28.429,11.766,53.941,29.26,76.324,50.4a317.117,317.117,0,0,1,28.709,31.055q1.36,1.668,2.691,3.364,5.579,7.051,10.794,14.392,7.486,10.528,14.214,21.522c1.234,2.019,2.458,4.047,3.654,6.093.8,1.374,1.617,2.757,2.411,4.149a.279.279,0,0,1,.037.093c12.439,21.878,22.606,45.222,27.905,69.623.935,4.318,1.72,8.654,2.327,13.027v.009q.8,5.565,1.206,11.186a165.384,165.384,0,0,1-.215,26.531Z",
    transform: "translate(402.493 91.627)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.935,453.864c-3.486,40.26-21.036,79.165-46.073,111.341q-1.57,2.019-3.177,4-3.617,4.458-7.42,8.747-4.654,5.285-9.579,10.327-4.009,4.149-8.205,8.121-3.238,3.1-6.551,6.075c-26.569,24.008-57.091,43.82-88.538,61.147-61.371,33.8-128.639,59.409-198.608,63.137s-142.994-16.317-194.3-64.034c-69.146-64.306-88.445-171.562-60.371-261.717,18.672-59.979,56.782-114.238,108.649-149.676,51.418-35.129,116.284-50.942,177.674-40.606,49.007-29.784,113.163-30.354,166.441-8.308,28.429,11.766,53.941,29.26,76.324,50.4a317.117,317.117,0,0,1,28.709,31.055q1.36,1.668,2.691,3.364,5.579,7.051,10.794,14.392,7.486,10.528,14.214,21.522c1.234,2.019,2.458,4.047,3.654,6.093.8,1.374,1.617,2.757,2.411,4.149a.279.279,0,0,1,.037.093c12.439,21.878,22.606,45.222,27.905,69.623.935,4.318,1.72,8.654,2.327,13.027v.009q.8,5.565,1.206,11.186a165.384,165.384,0,0,1-.215,26.531Z",
    transform: "translate(402.493 91.627)",
    fill: "#0284c7",
    opacity: 0.191
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.355,529.588,591.612,414.006,726.4,534.217a3.216,3.216,0,1,0,3.956-4.63Z",
    transform: "translate(380.503 76.767)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.174,
    cy: 83.174,
    r: 83.174,
    transform: "translate(709.51 381.189)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,374.437a75.749,75.749,0,1,1-66.911-75.286A75.693,75.693,0,0,1,468,374.437Z",
    transform: "translate(398.513 84.319)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.363,
    cy: 23.363,
    r: 23.363,
    transform: "translate(754.368 410.16)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.106,354.588A23.365,23.365,0,0,1,447.313,316.2a75.747,75.747,0,0,1,25.793,38.391Z",
    transform: "translate(390.453 83.169)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.411,
    cy: 8.411,
    r: 8.411,
    transform: "translate(807.637 475.578)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.447,457.159a8.454,8.454,0,0,1-.29,2.187,74.322,74.322,0,0,1-16.345-3.962,8.412,8.412,0,0,1,16.635,1.776Z",
    transform: "translate(395.022 74.492)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.434,374.586a16.823,16.823,0,0,1-15.7,16.784A76.21,76.21,0,0,1,319.379,358,16.822,16.822,0,0,1,333.434,374.586Z",
    transform: "translate(398.505 80.433)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(1143.296 421.375)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1112.816 340.074)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(788.532 736.318)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1124.292 537.865)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(862 554.079)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.339,
    cy: 16.339,
    r: 16.339,
    transform: "translate(723.894 602.88)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(827.782 635.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1033.381 319.515)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(912.825 750.336)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(882.92 338.205)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(935.254 436.332)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(855.145 677.111)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1091.583 690.195)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(986.915 572.442)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1040.183 436)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.008,
    cy: 4.008,
    r: 4.008,
    transform: "translate(1135.043 499.488)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.008,
    cy: 4.008,
    r: 4.008,
    transform: "translate(972.434 366.784)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.008,
    cy: 4.008,
    r: 4.008,
    transform: "translate(972.434 642.472)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.636,651.383q-18.1,0-39.677-1.368c-74.4-4.725-170.775-21.151-271.367-46.252S339.208,547.883,271.309,517.1c-33.076-15-58.461-29.192-75.45-42.192-17.987-13.763-25.855-25.76-23.386-35.655,4.811-19.278,47.41-23.5,82.3-23.639l.012,2.8c-47.912.2-76.178,7.838-79.59,21.515-4.347,17.42,31.108,44.615,97.273,74.615,67.75,30.717,160.372,61.436,260.8,86.5S729.9,642.5,804.137,647.217c72.5,4.605,116.577-2.745,120.924-20.166,3.609-14.463-20.184-35.77-67-60l1.289-2.49c34.014,17.6,73.5,42.85,68.428,63.164-2.47,9.9-15.051,16.789-37.4,20.488C877.649,650.326,862,651.383,843.636,651.383Z",
    transform: "translate(407.97 76.661)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.3,693.374c-33.269,0-64.2-1.141-91.886-3.444-36.191-3.012-64.87-7.853-85.24-14.389-21.566-6.921-33.007-15.576-34.006-25.726-1.947-19.773,36.759-38.059,69.572-49.917l.953,2.638c-45.06,16.283-69.116,32.976-67.735,47.005,1.759,17.868,44.29,31.57,116.688,37.594,74.132,6.168,171.691,3.983,274.7-6.159s199.127-27.014,270.634-47.517C920.819,613.436,959.863,591.7,958.1,573.837c-1.46-14.835-31.029-26.908-83.26-34l.377-2.778c37.951,5.151,83.622,15.664,85.673,36.5,1,10.15-8.535,20.87-28.338,31.862-18.7,10.382-45.889,20.721-80.8,30.73C780.093,656.7,683.8,673.611,580.626,683.767,515.9,690.137,453.3,693.374,397.3,693.374Z",
    transform: "translate(407.049 68.711)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.339,
    cy: 16.339,
    r: 16.339,
    transform: "translate(1347.23 619.702)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.339,
    cy: 16.339,
    r: 16.339,
    transform: "translate(873.42 230)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.339,
    cy: 16.339,
    r: 16.339,
    transform: "translate(581.844 618.768)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.002,
    cy: 10.002,
    r: 10.002,
    transform: "translate(689.111 321.379)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.002,
    cy: 10.002,
    r: 10.002,
    transform: "translate(642.384 700.803)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.002,
    cy: 10.002,
    r: 10.002,
    transform: "translate(1324.597 537.257)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.339,
    cy: 16.339,
    r: 16.339,
    transform: "translate(1166.865 772.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(1183.936 595.96)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1262.788 554.397)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1183.353 533.838)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1183.353 460.935)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1190.155 650.322)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.008,
    cy: 4.008,
    r: 4.008,
    transform: "translate(1220.532 391.387)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.558,467.994l64.805-53.987-62.957,56.15a1.5,1.5,0,1,1-1.848-2.162Z",
    transform: "translate(216.024 -127.383)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.89,64.887,0,0,75.669,67.486a1.806,1.806,0,1,0,2.221-2.6Z",
    transform: "translate(731.38 743.189) rotate(-84)",
    fill: "#f0f0f0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.46,
    cy: 3.46,
    r: 3.46,
    transform: "translate(872.769 785.846)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.008,
    cy: 4.008,
    r: 4.008,
    transform: "translate(980.45 766.461)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1013.091 789.379)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.021,
    cy: 2.021,
    r: 2.021,
    transform: "translate(1013.091 716.475)",
    fill: "#f0f0f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawStars5Pgw);
export default __webpack_public_path__ + "static/media/undraw_stars_5pgw.ae2cdaef3e3524c6f53a0b1a1f9ed227.svg";
export { ForwardRef as ReactComponent };